// some nice polyfills for IE
if ((typeof Array.prototype.find) === 'undefined') {
    Array.prototype.find = function(callback) {
        for (var i = 0; i < this.length; ++i) {
            if (callback(this[i], i)) {
                return this[i];
            }
        }
        return null;
    };
}